import { containerFrom } from '@vakantiesnl/components/src/styles/container';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

import { FLIGHT_OVERVIEW_NAME, FLIGHT_OVERVIEW_SIZE } from './constants';

export const useStyles = makeStyles()((theme) => ({
	transferFlightContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.medium,
		containerType: 'inline-size',
		containerName: FLIGHT_OVERVIEW_NAME,
		/** only for transfers in ibed */
		// marginLeft: theme.spacing.large,

		// [containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
		// 	marginLeft: 0,
		// },
	},
	transferFlightSegmentContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
	},
	transferFlight: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
	},
	transferTime: {
		display: 'flex',
		gap: theme.spacing.xxsmall,
		alignItems: 'center',
		font: theme.flightSelection.stops.font,
		color: theme.flightSelection.stops.color.transfer,

		[containerFrom(FLIGHT_OVERVIEW_SIZE, FLIGHT_OVERVIEW_NAME)]: {
			justifyContent: 'center',
		},
	},
}));
